<template>
	<v-form ref="unitary_form">
		<div class="ml-1 background--text text--lighten-5">
			Contrat *
		</div>
		<v-autocomplete
			dense
			solo
			:items="legacy_contracts"
			item-value="id"
			item-text="name"
			class="grv-input"
			name="Contrat"
			:rules="[checkRequired]"
			:menu-props="{contentClass: 'grv-menu'}"
			v-model="form.parameters.legacy_contract_id">
		</v-autocomplete>

		<div class="ml-1 background--text text--lighten-5">
			Type d'asset *
		</div>
		<v-autocomplete
			dense
			solo
			class="grv-input"
			name="Type d'asset"
			:rules="[checkRequired]"
			:menu-props="{contentClass: 'grv-menu'}"
			:items="source_types"
			v-model="form.parameters.source_type">
		</v-autocomplete>

		<div class="ml-1 background--text text--lighten-5">
			Précision
		</div>
		<v-text-field
			dense
			solo
			name="Précision"
			class="grv-input"
			v-model="form.parameters.precision"
			hint="Une précision sur l'asset.">
		</v-text-field>

		<div class="ml-1 background--text text--lighten-5">
			Type de QC *
		</div>
		<v-select
			dense
			solo
			name="Type de QC"
			:rules="[checkRequired]"
			class="grv-input"
			:menu-props="{contentClass: 'grv-menu'}"
			:items="qc_levels"
			v-model="form.parameters.qc_level">
		</v-select>
	</v-form>
</template>

<script>
export default {
	props: [ 'details', 'wf_data', 'form' ],
	data () {
		return {
			legacy_contracts: []
		}
	},
	computed: {
		source_types () {
			if (this.wf_data) {
				let param = this.wf_data.parameters.find(param => {
					return param.name === 'source_type'
				})
				if (param) return param.choices
			}
			return []
		},
		qc_levels () {
			if (this.wf_data) {
				let param = this.wf_data.parameters.find(param => {
					return param.name === 'qc_level'
				})
				if (param) return param.choices
			}
			return []
		}
	},
	methods: {
		getLegacyContracts () {
			this.$apiPublic.get_legacy_contracts()
				.then(results => {
					this.legacy_contracts = results
					if (this.details.hasOwnProperty('legacy_contract_id')) {
						for (let i = 0; i < results.length; i++) {
							const contract = results[i]
							if (contract.id === this.details['legacy_contract_id']) {
								this.form.parameters.legacy_contract_id = contract.id
								break
							}
						}
					}
				})
				.catch(error => {
					console.log(error)
				})
		},
		checkRequired (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		},
		validate () {
			let isValid = this.$refs.unitary_form.validate()
			this.form.isValid = isValid
			return isValid
		},
		resetValidation () {
			return this.$refs.unitary_form.resetValidation()
		}
	},
	mounted () {
		this.getLegacyContracts()
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/forms/launcher_form_legacy.vue